import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { getAccessToken } from '../store/actions/auth';
import API_BASE_URL from '../config/baseUrl';

const fetchMatkaBetStatus = async function() {
  try {
    const token = getAccessToken();
    if (!token) {
      return { success: false, error: 'No access token found' };
    }

    const response = await axios.post(
      API_BASE_URL + '/ant-pro/get-downline-mtk-csno-bet-status',
      {},
      { headers: { Authorization: 'Bearer ' + token } }
    );

    const data = response.data;
    if (data.status === false) {
      return { success: false, error: data.message || 'Failed to fetch matka bet status' };
    }

    return { success: true, data: data.data || {} };
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to fetch matka bet status';
    return { success: false, error: errorMessage };
  }
};

const updateMatkaBetLock = async function(userId, isLock) {
  try {
    const token = getAccessToken();
    if (!token) {
      return { success: false, error: 'No access token found' };
    }

    const response = await axios.post(
      API_BASE_URL + '/ant-pro/lock-unlock-downline-matka',
      { userId: userId, isLock: isLock },
      { headers: { Authorization: 'Bearer ' + token } }
    );

    const data = response.data;
    if (data.status === false) {
      return { success: false, error: data.message || 'Failed to update matka bet lock' };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to update matka bet lock';
    return { success: false, error: errorMessage };
  }
};

const updateCasinoBetLock = async function(userId, isLock) {
  try {
    const token = getAccessToken();
    if (!token) {
      return { success: false, error: 'No access token found' };
    }

    const response = await axios.post(
      API_BASE_URL + '/ant-pro/lock-unlock-downline-casino',
      { userId: userId, isLock: isLock },
      { headers: { Authorization: 'Bearer ' + token } }
    );

    const data = response.data;
    if (data.status === false) {
      return { success: false, error: data.message || 'Failed to update casino bet lock' };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage = err.response?.data?.message || 'Failed to update casino bet lock';
    return { success: false, error: errorMessage };
  }
};

const MatkaBetStatusPage = () => {
  const { user } = useSelector(function(state) {
    return state.auth;
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [matkaLock, setMatkaLock] = useState(false);
  const [casinoLock, setCasinoLock] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(function() {
    const loadData = async function() {
      setLoading(true);
      setError(null);

      const result = await fetchMatkaBetStatus();
      if (result.success) {
        setMatkaLock(Boolean(result.data?.matkaLock));
        setCasinoLock(Boolean(result.data?.casinoLock));
      } else {
        setError(result.error);
        setMatkaLock(false);
        setCasinoLock(false);
      }

      setLoading(false);
    };

    loadData();
  }, []);

  const handleToggle = async function(type, nextValue) {
    if (!user?.userId || updating) return;
    setUpdating(true);
    setError(null);

    const result = type === 'matka'
      ? await updateMatkaBetLock(user.userId, nextValue)
      : await updateCasinoBetLock(user.userId, nextValue);

    if (result.success) {
      if (type === 'matka') {
        setMatkaLock(nextValue);
      } else {
        setCasinoLock(nextValue);
      }
    } else {
      setError(result.error || 'Failed to update lock status');
    }

    setUpdating(false);
  };

  return (
    <div className="w-full">
      <div className="flex justify-center">
        <div className="w-full max-w-6xl px-2">
          <div className="bg-white rounded shadow border border-gray-200">
            <div className="bg-gray-600 px-5 py-3">
              <span className="text-2xl text-white font-normal capitalize">
                Matka Bet Status
              </span>
            </div>

            <div className="overflow-x-auto">
              {loading ? (
                <div className="flex justify-center items-center py-12">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                </div>
              ) : error ? (
                <div className="p-4 text-red-500 text-center">{error}</div>
              ) : (
                <div className="p-6 flex flex-col gap-4">
                  <div className="flex items-center justify-between border border-gray-300 p-4">
                    <div className="text-sm font-medium">Matka Bet Lock</div>
                    <button
                      onClick={function() { handleToggle('matka', !matkaLock); }}
                      disabled={updating || !user?.userId}
                      className={
                        (matkaLock ? 'bg-red-600' : 'bg-green-600') +
                        ' text-white px-4 py-1 disabled:opacity-50'
                      }
                      style={{ borderRadius: 0 }}
                    >
                      {matkaLock ? 'Locked' : 'Unlocked'}
                    </button>
                  </div>
                  <div className="flex items-center justify-between border border-gray-300 p-4">
                    <div className="text-sm font-medium">Casino Bet Lock</div>
                    <button
                      onClick={function() { handleToggle('casino', !casinoLock); }}
                      disabled={updating || !user?.userId}
                      className={
                        (casinoLock ? 'bg-red-600' : 'bg-green-600') +
                        ' text-white px-4 py-1 disabled:opacity-50'
                      }
                      style={{ borderRadius: 0 }}
                    >
                      {casinoLock ? 'Locked' : 'Unlocked'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatkaBetStatusPage;
